import domready from "domready";

/**
 * Deprecated: Use `toujou-accordion` web component instead
 */
domready(function () {
  var accordionContainer = document.querySelectorAll("div.accordion");
  if (accordionContainer.length > 0) {
    console.warn('Deprecated accordion: Use `toujou-accordion` web component instead');
    Array.prototype.forEach.call(accordionContainer, function (el) {
      accordion(el, "accordion__panel--active", "accordion__content--active");
    });
  }
});

/**
 * @deprecated
 */
function accordion(container, panelActiveClass, contentClassActive) {
  var accordionPanels = container.getElementsByClassName("accordion__panel");
  Array.prototype.forEach.call(accordionPanels, function (el, i) {
    var identifier = el.dataset.for;
    var openOnLoad = el.dataset.open;
    if (openOnLoad === "true") {
      togglePanel(identifier, panelActiveClass, container);
      toggleContent(identifier, contentClassActive, container);
      container.dispatchEvent(createNewEvent("accordion-change"));
    }
    el.addEventListener("click", function (e) {
      e.preventDefault();
      togglePanel(identifier, panelActiveClass, container);
      toggleContent(identifier, contentClassActive, container);
      container.dispatchEvent(createNewEvent("accordion-change"));

      // This would work too, but we have IE support so i have to do the long version below
      // window.dispatchEvent(new Event('resize'));
      var evt = window.document.createEvent("UIEvent");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
    });
  });
}

function toggleContent(identifier, classActive, container) {
  var content = container.querySelector("[data-content=\"" + identifier + "\"]");
  if (content.classList.contains(classActive)) {
    content.classList.remove(classActive);
    content.setAttribute("aria-hidden", "true");
  } else {
    content.classList.add(classActive);
    content.setAttribute("aria-hidden", "false");
  }
}

function togglePanel(identifier, classActive, container) {
  var panel = container.querySelector("[data-for=\"" + identifier + "\"]");
  if (panel.classList.contains(classActive)) {
    panel.classList.remove(classActive);
    panel.setAttribute("aria-expanded", "false");
  } else {
    panel.classList.add(classActive);
    panel.setAttribute("aria-expanded", "true");
  }
}

function createNewEvent(eventName) {
  if (typeof Event === "function") {
    return new Event(eventName);
  } else {
    var event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    return event;
  }
}
